<template>
  <div>
    <Head :title="form.title" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/njoftimet">Njoftimet</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.title }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/2" label="Titulli" />

          <textarea-input v-model="form.body" :error="form.errors.body" class="pb-8 pr-6 w-full lg:w-1/2" label="Përmbajtja" />

<!--          <select-input v-model="form.role_id" :error="form.errors.role_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Roli">-->
<!--            <option :value="null">Të gjitha</option>-->
<!--            <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>-->
<!--          </select-input>-->

          <div class="pb-8 pr-6  w-full">
            <label class="form-label">Për rolet:</label>
            <Multiselect
              v-model="form.role_ids"
              :options="filterRoles.options"
              :error="form.errors.role_ids"
              mode="tags"
              :close-on-select="true"
              :searchable="true"
              :create-option="false"
              placeholder="Të gjitha"

            />
            <div v-if="form.errors.role_ids" class="form-error">{{ form.errors.role_ids }}</div>
          </div>

<!--          <select-input v-model="form.user_id" :error="form.errors.user_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Përdoruesi">-->
<!--            <option :value="null">Të gjithë</option>-->
<!--            <option v-for="user in selectedUsers" :key="user.id" :value="user.id">{{ user.first_name }} {{user.last_name}}</option>-->
<!--          </select-input>-->

          <div class="pb-8 pr-6  w-full">
            <label class="form-label">Për përdoruesit:</label>
            <Multiselect
              v-model="form.user_ids"
              :options="filterUsers.options"
              :error="form.errors.user_ids"
              mode="tags"
              :close-on-select="true"
              :searchable="true"
              :create-option="false"
              placeholder="Të gjithë"
            />
            <div v-if="form.errors.user_ids" class="form-error">{{ form.errors.user_ids }}</div>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2" >
            <label class="form-label">Shfaq nga data:</label>
            <input v-model="form.start_date" :error="form.errors.start_date"  type="date" class="form-select focus:ring-0 hover:border-indigo-500">
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="form-label">Shfaq deri në datën(duke mos e përfshirë):</label>
            <input v-model="form.end_date" :error="form.errors.end_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="user.role === 'superadmin'" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Fshij</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Edito</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import {computed} from 'vue'
import axios from 'axios'
import TextareaInput from '@/Shared/TextareaInput'
import Multiselect from '@vueform/multiselect'


export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextareaInput,
    Multiselect
  },
  layout: Layout,
  props: {
    notification: Object,
    roles: Array,
    users: Array,
    roleIds: Object,
    userIds: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        title: this.notification.data.title,
        body: this.notification.data.body,
        role_id: this.notification.data.role_id,
        user_id: this.notification.data.user_id,
        start_date: this.notification.data.start_date_display_format,
        end_date: this.notification.data.end_date_display_format,
        role_ids: this.roleIds.map(function (role){return role.id}),
        user_ids: this.userIds.map(function (user){return user.id}),

      }),
      filterRoles: {
        options: this.roles.map(function(role){
          return {value: role.id, label: role.name}
        }),
      },
      filterUsers: {
        options: this.users.map(function(user){
          return {value: user.id, label: user.first_name + ' ' + user.last_name}
        }),
      },
      selectedUsers: this.users
    }
  },
  watch: {
    'form.role_ids'(){
      this.getUsers()
    }
  },
  methods: {
    update() {
      this.form.put(`/admin/njoftimet/${this.notification.data.id}`)
    },
    destroy() {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.delete(`/admin/njoftimet/${this.notification.data.id}`)
      }
    },
    getUsers() {
      let self = this
      // self.selectedUsers = []
      self.filterUsers.options = []
      self.form.user_ids = []
      axios.get('/ajax/list/users/by-multiple-roles', {
        params: {
          role_ids: self.form.role_ids,
        },
      }).then(function (result) {
        self.filterUsers.options = result.data.users.map(function(user){
          return {value: user.id, label: user.first_name + ' ' + user.last_name}
        })
        // self.selectedUsers = result.data.users
        // self.form.user_id = null
      })
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },

}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

